// src/features/equipment/services/equipment.js
import { apiClient } from '../../../services/api/client';

export const equipmentAPI = {
  // Create equipment
  createEquipment: (data) => 
    apiClient.post('/api/v1/rooms-equipment/equipment/', data),
  
  // Get equipment by ID
  getEquipmentById: (equipmentId) => 
    apiClient.get(`/api/v1/rooms-equipment/equipment/${equipmentId}`),
  
  // List equipment by room
  listEquipmentByRoom: (roomId, params = {}) => 
    apiClient.get(`/api/v1/rooms-equipment/equipment/room/${roomId}`, { params }),
  
  // List equipment by department
  listEquipmentByDepartment: (params = {}) => 
    apiClient.get(`/api/v1/rooms-equipment/equipment/`, { params }),
  
  // Update equipment
  updateEquipment: (equipmentId, data) => 
    apiClient.put(`/api/v1/rooms-equipment/equipment/${equipmentId}`, data),
  
  // Deactivate equipment
  deactivateEquipment: (equipmentId, data) => 
    apiClient.post(`/api/v1/rooms-equipment/equipment/${equipmentId}/deactivate`, data),
  
  // Reactivate equipment
  reactivateEquipment: (equipmentId) => 
    apiClient.post(`/api/v1/rooms-equipment/equipment/${equipmentId}/reactivate`),
  
  // Update receipt control
  updateReceiptControl: (equipmentId, data) => 
    apiClient.patch(`/api/v1/rooms-equipment/equipment/${equipmentId}/receipt-control`, data),
  
  // Delete equipment
  deleteEquipment: (equipmentId) => 
    apiClient.delete(`/api/v1/rooms-equipment/equipment/${equipmentId}`),
  
  // Filter equipment
  filterEquipment: (params = {}) =>
    apiClient.get('/api/v1/rooms-equipment/equipment/filter', { params }),

  // List tasks linked to equipment; { relation_type, limit, offset } for one page (limit 0 = counts only)
  listEquipmentTasks: (equipmentId, params = {}) =>
    apiClient.get(`/api/v1/rooms-equipment/equipment/${equipmentId}/tasks/`, { params }),

  // List files attached to equipment
  listEquipmentFiles: (equipmentId) =>
    apiClient.get(`/api/v1/rooms-equipment/equipment/${equipmentId}/files`),

  // Attach a file to equipment
  attachEquipmentFile: (equipmentId, data) =>
    apiClient.post(`/api/v1/rooms-equipment/equipment/${equipmentId}/files`, data),

  // Remove a file attachment from equipment
  removeEquipmentFile: (equipmentId, equipmentFileId) =>
    apiClient.delete(`/api/v1/rooms-equipment/equipment/${equipmentId}/files/${equipmentFileId}`),

  // ── Maintenance ────────────────────────────────────────────────────────────

  // List maintenance cases for one piece of equipment (newest first)
  listEquipmentMaintenance: (equipmentId, params = {}) =>
    apiClient.get(`/api/v1/rooms-equipment/equipment/${equipmentId}/maintenance`, {
      params,
      paramsSerializer: { indexes: null },
    }),

  // Report a fault (any staff member with equipment:read)
  reportFault: (equipmentId, data) =>
    apiClient.post(`/api/v1/rooms-equipment/equipment/${equipmentId}/maintenance/report`, data),

  // Pull for maintenance ({ mode: 'pull' }) or record past work ({ mode: 'record' })
  createMaintenance: (equipmentId, data) =>
    apiClient.post(`/api/v1/rooms-equipment/equipment/${equipmentId}/maintenance`, data),

  getMaintenanceCase: (maintenanceId) =>
    apiClient.get(`/api/v1/rooms-equipment/maintenance/${maintenanceId}`),

  updateMaintenanceCase: (maintenanceId, data) =>
    apiClient.patch(`/api/v1/rooms-equipment/maintenance/${maintenanceId}`, data),

  pullReportedCase: (maintenanceId, data = {}) =>
    apiClient.post(`/api/v1/rooms-equipment/maintenance/${maintenanceId}/pull`, data),

  addMaintenanceNote: (maintenanceId, data) =>
    apiClient.post(`/api/v1/rooms-equipment/maintenance/${maintenanceId}/notes`, data),

  completeMaintenance: (maintenanceId, data) =>
    apiClient.post(`/api/v1/rooms-equipment/maintenance/${maintenanceId}/complete`, data),

  cancelMaintenance: (maintenanceId, data = {}) =>
    apiClient.post(`/api/v1/rooms-equipment/maintenance/${maintenanceId}/cancel`, data),

  attachMaintenanceFile: (maintenanceId, data) =>
    apiClient.post(`/api/v1/rooms-equipment/maintenance/${maintenanceId}/files`, data),

  removeMaintenanceFile: (maintenanceId, maintenanceFileId) =>
    apiClient.delete(`/api/v1/rooms-equipment/maintenance/${maintenanceId}/files/${maintenanceFileId}`),
};
